type DeepPartial<TObject> = {
  [P in keyof TObject]?: TObject[P] extends object
    ? DeepPartial<TObject[P]>
    : TObject[P];
};

const isPlainObject = (value: unknown): value is Record<string, unknown> => {
  return value !== null && typeof value === 'object' && !Array.isArray(value);
};

export const deepMerge = <TObject extends Record<string, unknown>>(
  target: TObject,
  source: DeepPartial<TObject>,
): TObject => {
  const sourceEntries = Object.entries(source).filter(
    ([, value]) => value !== undefined,
  );

  return sourceEntries.reduce(
    (merged, [key, sourceValue]) => {
      const targetValue = merged[key];

      if (isPlainObject(sourceValue) && isPlainObject(targetValue)) {
        return {
          ...merged,
          [key]: deepMerge(
            targetValue as TObject,
            sourceValue as DeepPartial<TObject>,
          ),
        };
      }

      return {
        ...merged,
        [key]: sourceValue,
      };
    },
    { ...target },
  );
};
